/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { never } from '../../../util.type';
import OrientationEnum from '../../orientation/orientation-enum';

/**
 * Komunikátor orientací obrazovky pro Ki-Wi Server.
 */
class CommunicatorOrientation {
  /**
   * Vygeneruje orientaci obrazovky.
   * @param {OrientationEnum | null | undefined} value Orientace obrazovky.
   * @returns {0 | 90 | 180 | 270 | undefined} Orientace obrazovky ve formátu pro server.
   */
  static generate(value) {
    switch (value) {
      case OrientationEnum.CLOCKWISE_0:
        return 0;
      case OrientationEnum.CLOCKWISE_90:
        return 90;
      case OrientationEnum.CLOCKWISE_180:
        return 180;
      case OrientationEnum.CLOCKWISE_270:
        return 270;
      // TODO: Jak mapovat UNKNOWN?
      case OrientationEnum.UNKNOWN:
      case null:
      case undefined:
        break;
      default:
        never(value);
    }
    return undefined;
  }

  /**
   * Zpracuje orientaci obrazovky.
   * @param {number | undefined} value Nastavení orientace ve formátu, který vrací server.
   * @returns {OrientationEnum | undefined} Orientace obrazovky.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 0:
        result = OrientationEnum.CLOCKWISE_0;
        break;
      case 90:
        result = OrientationEnum.CLOCKWISE_90;
        break;
      case 180:
        result = OrientationEnum.CLOCKWISE_180;
        break;
      case 270:
        result = OrientationEnum.CLOCKWISE_270;
        break;
      default:
        result = undefined;
    }
    return result;
  }
}

export default CommunicatorOrientation;
